import type { NumberInputProps } from '@mantine/core';
import { NumberInput as MantineNUmberInput } from '@mantine/core';
import React from 'react';

import styles from './NumberInput.module.css';

export const LBNumberInput = React.forwardRef<
  React.ElementRef<typeof MantineNUmberInput>,
  NumberInputProps
>((props, ref) => (
  <MantineNUmberInput
    {...props}
    ref={ref}
    hideControls
    classNames={styles}
    inputMode='numeric'
    inputWrapperOrder={['label', 'input', 'error', 'description']}
    rightSectionPointerEvents='all'
  />
));
